<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-divide`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.04309 12H6.41439" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3146 12H13.6859" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.586 12H20.9573" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorDivide',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
